import { useTranslation } from 'react-i18next'
import { LinkButton } from '../../common/components/button/LinkButton'
import { Card } from '../../composites/GamesOverview/components/card/Card'
import { TGameCard, TUser } from '../../types/commonTypes'
import styles from './Dashboard.module.css'

type LTIOpenerProps = {
  user?: TUser | null
  game?: TGameCard
}

export const LTIOpener: React.FC<LTIOpenerProps> = ({ user, game }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.ltiOpener}>
      <div className={styles.ltiText}>
        {t('lti_frame.too_small_window', 'Go to Seppo to find or create a game for this course.')}
      </div>
      <LinkButton
        href={user?.resultsUrl}
        label={t('lti.open_to_new_window', 'Open to a new window')}
        target='_blank'
        rel='noreferrer'
      />
      {game && (
        <>
          <br />
          <div className={styles.ltiSelectedGame}>
            <Card game={game} onGameAction={() => {}} noActions />
          </div>
          <div style={{ marginTop: -15 }} className={styles.ltiText}>
            {t('lti_frame.current_gam', 'Currently active game')}
          </div>
        </>
      )}
    </div>
  )
}
